import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import { Icon } from '@bb/elements-web';
import LiveConciergeCard from './components/LiveConciergeCard';
import PriceEstimatorCard from './components/PriceEstimatorCard';
import AppointmentDeskCard from './components/AppointmentDeskCard';
import AnsweringServiceContext from '../AnsweringServiceContext';

/**
 * The first page in the flow for a user signing up to pay for a new
 * Answering Service subscription, accessed by clicking the 'Learn More'
 * button. */
const LearnMore: React.FC = () => {
  const [showEstimator, setShowEstimator] = useState(false);

  const handleToggleEstimator = () => {
    setShowEstimator(prev => !prev);
  };
  const { billingRedirection, currentSubscriptionType } = useContext(
    AnsweringServiceContext,
  );

  return (
    <StyledPageWrapper>
      <StyledHeader>
        <BackArrow onClick={billingRedirection}>
          <Icon icon="fullArrowLeftOutlined" size={20} color="primary" />
        </BackArrow>
        <h1>Subscribe to Live Concierge</h1>
      </StyledHeader>
      <CardsContainer>
        {currentSubscriptionType === AnsweringServiceType.AppointmentDesk && (
          <AppointmentDeskCard />
        )}
        <LiveConciergeCard
          showEstimator={showEstimator}
          onToggleEstimator={handleToggleEstimator}
        />
        {showEstimator && <PriceEstimatorCard />}
      </CardsContainer>
    </StyledPageWrapper>
  );
};

export default LearnMore;

const StyledPageWrapper = styled.div`
  padding: 0 24px 24px 24px;
  max-width: 1200px;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1a1b21;
  }
`;

const BackArrow = styled.button`
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
`;
